export default function FeatureComparison() {
  const rows = [
    { feature: 'Automation', mulebuy: 'High', manual: 'None', basic: 'Low' },
    { feature: 'Efficiency', mulebuy: 'Excellent', manual: 'Poor', basic: 'Medium' },
    { feature: 'Scalability', mulebuy: 'Strong', manual: 'Weak', basic: 'Limited' },
    { feature: 'Data Accuracy', mulebuy: 'High', manual: 'Low', basic: 'Medium' },
    { feature: 'Best For', mulebuy: 'Business & Dropshipping', manual: 'Small Users', basic: 'Beginners' },
  ];

  return (
    <section className="bg-background-100 section-padding">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            Why Use a <span className="italic text-accent-500">Mulebuy Spreadsheet</span>?
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-2xl mx-auto">
            A Mulebuy Spreadsheet helps users track sourcing and purchasing data efficiently, organize large product datasets, and improve decision-making with structured data.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[600px] border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300">
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-700 font-label">Feature</th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-accent-600 font-label bg-accent-50/50 rounded-t-lg">
                  Mulebuy Spreadsheet
                </th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-500 font-label">Manual Tracking</th>
                <th className="text-center py-3 px-4 text-sm font-semibold text-foreground-500 font-label">Basic Tools</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={row.feature} className={`border-b border-background-200 ${idx % 2 === 0 ? 'bg-background-50/50' : ''}`}>
                  <td className="py-3.5 px-4 text-sm font-medium text-foreground-800 font-label">{row.feature}</td>
                  <td className="py-3.5 px-4 text-center text-sm font-semibold text-accent-600 bg-accent-50/30">{row.mulebuy}</td>
                  <td className="py-3.5 px-4 text-center text-sm text-foreground-500">{row.manual}</td>
                  <td className="py-3.5 px-4 text-center text-sm text-foreground-500">{row.basic}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}